import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type CGMDataSamplePayload = {
  status?: number;
  value?: number;
};

export type CGMDataEvent = {
  status?: number;
  value?: number;
};

const cGMDataSampleSchema = z.object({
  status: cz.permissive(z.number()),
  value: cz.permissive(z.number()),
});

export const LID_CGM_DATA = {
  value: 0x97,
  name: "CGM Data Sample",
  format: "h........h....",
  fields: ["status", "value"],
  postprocess: rec => rec,
  schema: cGMDataSampleSchema,
} as const satisfies TandemEventDefinition<CGMDataSamplePayload, CGMDataEvent>;
